import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import AppNavbar from "../../Navbar/AppNavbar";
import Footer from "../../Navbar/Footer";
import "../../../assets/css/search.scss";
import { useDispatch, useSelector } from "react-redux";
import { loadMyListData, updateSavedSearchData } from "../../redux/action";
import { useNavigate } from "react-router-dom";
import EditMyListModal from "./EditMyListModal";
import DeleteMyListModal from "./DeleteMyListModal";

const MyList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
    const signInID = signInDetails[0]?.id;
    const sbnID = signInDetails[0]?.sbn_id;
    const role = signInDetails[0]?.role;
    const { myListData } = useSelector((state) => state.data);

    const limit = 24;
    const [currentPage, setCurrentPage] = useState(1);

    const [openMenuIndex, setOpenMenuIndex] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectedSearch, setSelectedSearch] = useState(null);

    const handleMenuToggle = (index) => {
        setOpenMenuIndex(openMenuIndex === index ? null : index);
    };

    const handleOpenEdit = (item) => {
        setSelectedSearch(item);
        setShowEditModal(true);
        setOpenMenuIndex(null);
    };

    const handleDeleteClick = (item) => {
        setSelectedSearch(item);
        setShowDeleteModal(true);
    };

    const fetchMyListData = () => {
        dispatch(loadMyListData(signInID, sbnID, role, currentPage, limit, setLoading));
    }

    useEffect(() => {
        fetchMyListData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [signInID, sbnID]);


    const handleView = (item) => {
        const provider = (
            item.provider ||
            item.PROVIDER ||
            null
        );
        console.log("MY LIST OPEN =>", {
            list_name: item.list_name,
            provider,
            raw: item,
        });
        navigate(`/viewed-contacts`, { state: { listName: item.list_name, provider: provider ? String(provider).toLowerCase() : null, }, });
    };

    return (
        <div className="page-layout">
            <AppNavbar />
            <div className="page-content">
                <div className="saved-search-container">
                    <div className="saved-search-header-container">
                        <div className="saved-search-header-div">
                            <p>My List</p>
                            <div className="saved-search-img-div">
                                <h5 className="m-0">List Names</h5>
                                <i className="fa-solid fa-list"></i>
                            </div>
                        </div>
                    </div>
                    <div className="saved-searches-body">
                        <Row className="m-0 saved-searches-card-row">
                            {myListData && myListData.length > 0 ? (
                                myListData.map((item, index) => (
                                    <Col
                                        md={3}
                                        sm={6}
                                        xs={12}
                                        className="saved-searches-card-col mb-4"
                                        key={index}
                                    >
                                        <Card
                                            className="modern-list-card h-100"
                                            onClick={() => handleView(item)}
                                        >
                                            {/* Top accent line */}
                                            <div className="card-accent-line"></div>

                                            <Card.Body className="modern-card-body">

                                                {/* Card Header */}
                                                <div className="modern-card-header">

                                                    {/* List Icon */}
                                                    <div className="list-icon-wrapper">
                                                        <i className="fa-solid fa-list-check"></i>
                                                    </div>

                                                    {/* List Name + Count */}
                                                    <div className="list-title-section">

                                                        <Card.Title className="modern-card-title">
                                                            {item.list_name}
                                                        </Card.Title>

                                                        <div className="contact-count">
                                                            <i className="fa-solid fa-users"></i>
                                                            <span>
                                                                {item.viewed_count ?? 0} contacts
                                                            </span>
                                                        </div>

                                                    </div>

                                                    {/* Three Dot Menu */}
                                                    <div className="card-menu-wrapper">

                                                        <button
                                                            className="card-menu-button"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleMenuToggle(index);
                                                            }}
                                                        >
                                                            <i className="fa-solid fa-ellipsis-vertical"></i>
                                                        </button>

                                                        {openMenuIndex === index && (
                                                            <div className="dropdown-card-options modern-dropdown">

                                                                <div
                                                                    className="dropdown-item modern-dropdown-item"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleOpenEdit(item);
                                                                    }}
                                                                >
                                                                    <i className="fa-solid fa-pen-to-square"></i>
                                                                    <span>Edit List</span>
                                                                </div>

                                                                <div
                                                                    className="dropdown-item modern-dropdown-item delete-item"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleDeleteClick(item);
                                                                    }}
                                                                >
                                                                    <i className="fa-solid fa-trash"></i>
                                                                    <span>Delete List</span>
                                                                </div>

                                                            </div>
                                                        )}

                                                    </div>

                                                </div>

                                                {/* Divider */}
                                                <div className="modern-card-divider"></div>

                                                {/* Date / Time */}
                                                <div className="modern-card-meta">

                                                    <div className="meta-item">
                                                        <div className="meta-icon">
                                                            <i className="fa-regular fa-calendar"></i>
                                                        </div>

                                                        <div>
                                                            <span className="meta-label">
                                                                Created
                                                            </span>

                                                            <span className="meta-value">
                                                                {new Date(
                                                                    item.list_created_datetime
                                                                ).toLocaleDateString()}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className="meta-item">
                                                        <div className="meta-icon">
                                                            <i className="fa-regular fa-clock"></i>
                                                        </div>

                                                        <div>
                                                            <span className="meta-label">
                                                                Time
                                                            </span>

                                                            <span className="meta-value">
                                                                {new Date(
                                                                    item.list_created_datetime
                                                                ).toLocaleTimeString([], {
                                                                    hour: "2-digit",
                                                                    minute: "2-digit"
                                                                })}
                                                            </span>
                                                        </div>
                                                    </div>

                                                </div>

                                                {/* Bottom View Section */}
                                                <div className="modern-card-footer">

                                                    <span className="view-list-text">
                                                        View contacts
                                                    </span>

                                                    <div className="view-arrow">
                                                        <i className="fa-solid fa-arrow-right"></i>
                                                    </div>

                                                </div>

                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))
                            ) : (
                                <p>No saved searches available</p>
                            )}
                        </Row>
                    </div>
                </div>

                {/* Modal Component (UI only) */}
                <EditMyListModal
                    show={showEditModal}
                    onHide={() => setShowEditModal(false)}
                    updateSavedSearchData={updateSavedSearchData}
                    selectedSearch={selectedSearch}
                    fetchMyListData={fetchMyListData}
                    role={role}
                    signInID={signInID}
                    sbnID={sbnID}
                />
                <DeleteMyListModal
                    show={showDeleteModal}
                    onHide={() => setShowDeleteModal(false)}
                    selectedSearch={selectedSearch}
                    fetchMyListData={fetchMyListData}
                    sbnID={sbnID}
                    signInID={signInID}
                />
            </div>
            <Footer />
        </div>
    );
};

export default MyList;